import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ExternalIntegrationDataSource } from 'dashboard/models/external-integration';
import { ApiModel } from 'lib/interfaces/api';

import { setExternalIntegration } from '../actions/external-integrations';

export const refreshDataSource = (dataSource: ExternalIntegrationDataSource) => {
  return async (dispatch: Dispatch) => {
    const response = await SessionClientDashboard.postResourceAction(
      { id: dataSource.id, type: ApiModel.ExternalIntegrationDataSource },
      'refresh',
    );
    const newDataSource = response.data;
    dispatch(setExternalIntegration(newDataSource as ExternalIntegrationDataSource));
  };
};
